import { render, staticRenderFns } from "./KusClientTab.vue?vue&type=template&id=31388187"
import script from "./KusClientTab.vue?vue&type=script&lang=js"
export * from "./KusClientTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports